export enum PLinkTarget {
  SELF = '_self',
  BLANK = '_blank',
}
